<template name="register-form">
  <form class="register-form">
    <v-card-title class="justify-center mb-5">
      <h1 class="headline text-center primary--text">
        {{ $cmsService.getContent(content, 'registration_header') }}
      </h1>
    </v-card-title>
    <v-card-text>
      <CustomAlert :show-alert="submitError" alert-type="error">
        <span class="body-2 cms_validatorMsg">
          {{ getError('validator_message') }}
        </span>
      </CustomAlert>
      <customNotification
        :show-notification="showNotification"
        :notification-type="registerStatus.type"
      >
        <span class="body-2 cms_">{{ registerStatus.msg }}</span>
      </customNotification>
      <v-text-field
        id="email"
        v-model="email"
        class="cms_eMail"
        :label="$cmsService.getContent(content, 'email_address')"
        :error-messages="emailErrors"
        outlined
        dense
        required
        @input="$v.email.$touch()"
        @keyup.enter.native="submit()"
      ></v-text-field>
      <v-text-field
        id="password"
        v-model="pwd"
        class="cms_pw"
        :label="$cmsService.getContent(content, 'password')"
        :error-messages="pwdErrors"
        :type="showPwd ? 'text' : 'password'"
        :append-icon="showPwd ? 'mdi-eye' : 'mdi-eye-off'"
        counter
        outlined
        dense
        required
        @input="$v.pwd.$touch()"
        @keyup.enter.native="submit()"
        @click:append="showPwd = !showPwd"
      ></v-text-field>
      <v-text-field
        id="repeatPassword"
        v-model="repeatPwd"
        class="cms_repeatPw"
        :label="$cmsService.getContent(content, 'repeat_password')"
        :error-messages="repeatPwdErrors"
        :type="showRepeatPwd ? 'text' : 'password'"
        :append-icon="showRepeatPwd ? 'mdi-eye' : 'mdi-eye-off'"
        counter
        outlined
        dense
        required
        @input="$v.repeatPwd.$touch()"
        @keyup.enter.native="submit()"
        @click:append="showRepeatPwd = !showRepeatPwd"
      ></v-text-field>
    </v-card-text>
    <v-card-actions class="justify-center">
      <v-btn
        id="register"
        class="text-center px-8"
        color="primary"
        dark
        depressed
        @click.stop="submit"
        >{{ $cmsService.getContent(content, 'registration_label') }}</v-btn
      >
    </v-card-actions>
  </form>
</template>
<script>
import { validationMixin } from 'vuelidate'
import { required, email, minLength, sameAs } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'
import CustomAlert from '@/components/CustomAlert'
import CustomNotification from '@/components/CustomNotification'
import registerJson from '@/data/json/forms/register.json'
export default {
  components: {
    CustomAlert,
    CustomNotification
  },
  mixins: [validationMixin],
  validations: {
    email: { required, email },
    pwd: {
      required,
      minLength: minLength(6),
      hasCapital(pwd) {
        return /[A-Z]/.test(pwd)
      },
      hasNum(pwd) {
        return /[0-9]/.test(pwd)
      },
      hasSpecialChar(pwd) {
        return /\W|_/.test(pwd)
      }
    },
    repeatPwd: {
      required,
      sameAsPassword: sameAs('pwd'),
      minLength: minLength(6)
    }
  },
  data: () => ({
    content: registerJson.data,
    email: '',
    pwd: '',
    repeatPwd: '',
    submitError: false,
    showNotification: false,
    registerStatus: {
      type: 'error',
      msg: ''
    },
    showPwd: false,
    showRepeatPwd: false
  }),
  computed: {
    emailErrors() {
      const errors = []
      if (!this.$v.email.$dirty) return errors
      !this.$v.email.email && errors.push(this.getError('email_invalid'))
      !this.$v.email.required && errors.push(this.getError('email_necessary'))
      return errors
    },
    pwdErrors() {
      const errors = []
      if (!this.$v.pwd.$dirty) return errors
      !this.$v.pwd.required && errors.push(this.getError('password_necessary'))
      !this.$v.pwd.minLength &&
        errors.push(this.getError('password_min_length'))
      !this.$v.pwd.hasCapital &&
        errors.push(
          'Ihr Passwort muss mindestens einen Großbuchstaben enthalten'
        )
      !this.$v.pwd.hasNum &&
        errors.push('Ihr Passwort muss mindestens eine Zahl enthalten')
      !this.$v.pwd.hasSpecialChar &&
        errors.push('Ihr Passwort muss mindestens ein Sonderzeichen enthalten')
      return errors
    },
    repeatPwdErrors() {
      const errors = []
      if (!this.$v.repeatPwd.$dirty) return errors
      !this.$v.repeatPwd.required &&
        errors.push(this.getError('password_repetition_necessary'))
      !this.$v.repeatPwd.minLength &&
        errors.push(this.getError('password_repetition_min_length'))
      !this.$v.repeatPwd.sameAsPassword &&
        errors.push(this.getError('passwords_not_identical'))
      return errors
    }
  },
  methods: {
    ...mapActions(['registerUser']),
    submit() {
      this.$v.$touch()
      this.showNotification = false
      this.submitError = false

      if (this.$v.$invalid) {
        this.submitError = true
      } else {
        return this.registerUser({
          isAdmin: true,
          email: this.email,
          password: this.pwd,
          confirmPassword: this.repeatPwd,
          confirmationURL: `${window.config.VUE_APP_BASE_URL}/registrationconfirmation/`
        })
          .then(() => {
            this.showNotification = true
            this.registerStatus = {
              msg: 'registration_successfull'
            }
            this.$router.push({ name: 'dashboard' })
          })
          .catch(e => {
            this.showNotification = true
            if (e.fromCms) {
              this.registerStatus = {
                type: 'error',
                msg: e.message
              }
            } else {
              const msg = this.getError(e.response.status)
              this.registerStatus = {
                type: 'error',
                msg: msg
              }
            }
          })
      }
    },
    getError: function (errorKey) {
      return this.$store.getters.error({
        errorKey: errorKey,
        route: this.$route.name
      })
    }
  }
}
</script>
